import {RightsColumnLabels} from '@entities/rights/constants';
import {RightsInventoryRequest} from '@entities/rights/rights-api-interfaces';
import {Inventory, RightsInventoryBuffer, RightsView} from '@entities/rights/rights.interfaces';
import {ExcelTab, ExcelTable} from '@shared/helpers/excel/excel.interfaces';

/**
 * 'RightsHelper' class definition.
 */
export class RightsHelper {
	/**
	 * Generate x l s.
	 * @param {Inventory[]} data
	 * @param {RightsInventoryBuffer} pinnedSearch
	 * @param {RightsInventoryRequest} params
	 * @param {string} today
	 * @returns {ExcelTab}
	 */
	public static generateXLS(
		data: Inventory[],
		pinnedSearch: RightsInventoryBuffer,
		params: RightsInventoryRequest,
		today?: string
	): ExcelTab {
		const tables: ExcelTable[] = [];
		const hideDealsColumns = params.MODE === RightsView.Availability;
		const columns = RightsColumnLabels.filter((item) => item.isDealColumn !== hideDealsColumns);
		const rows: unknown[] = [];

		rows.push({
			isSubHeader: true,
			title: `${params.MODE} from Date ${params.FROM_DATE}`,
		});
		rows.push({
			isColumnHeader: true,
		});

		let duplicatedData = false;
		if (pinnedSearch.size) {
			const dataLength = data.length;
			pinnedSearch.forEach((pinnedInventory) => {
				if (pinnedInventory.length === dataLength) {
					for (let rowId = 0; rowId < dataLength; rowId++) {
						for (const column of columns) {
							if (data[rowId][column.property] !== pinnedInventory[rowId][column.property]) {
								return;
							}
						}
					}
					duplicatedData = true;
				}
			});
		}
		if (!duplicatedData) {
			rows.push(...data);
		}

		if (pinnedSearch.size) {
			for (const [key, pinnedInventory] of pinnedSearch) {
				rows.push({
					isInlineHeader: true,
					title: `PINNED RESULTS: "${key}"`,
				});
				rows.push(...pinnedInventory);
			}
		}

		tables.push(new ExcelTable(rows, columns));

		return new ExcelTab(
			tables,
			columns,
			`Export Rights ${params.MODE} (generated on ${today})`,
			`${params.MODE} ${today}`
		);
	}
}
